import styled from 'styled-components'

import { Button as ButtonBase } from '@icontainers/design-system/dist/molecules/Button'
import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'

export const TitleSection = styled(TitleSectionBase)`
    background: ${(props) => props.theme.color[props.mode === 'Light' ? 'g200' : 'p600']};
`

export const Button = styled(ButtonBase)`
    width: 100%;

    button {
        width: 100%;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        width: auto;
    }
`
